import { eachDayOfInterval } from 'date-fns';

function blockoutDatesForDayOfWeek(dayOfWeek, blockoutDates) {
  return blockoutDates.filter(blockoutDate => {
    const { startsAt, endsAt } = blockoutDate.attributes
    const daysOfWeek = eachDayOfInterval({
      start: new Date(startsAt),
      end: new Date(endsAt)
    }).map(date => date.toLocaleString('en-US', { weekday: 'long' }));
    return daysOfWeek.includes(dayOfWeek);
  })
}

export default blockoutDatesForDayOfWeek;
